import UIApplication from 'UIComponents/app/UIApplication';
import { createBrowserHistory } from 'history';
import { renderRoot } from 'quartz-core/client';

// I18n Configuration
import createStandardI18nProvider from 'I18n/init/providers/createStandardI18nProvider';
import registerAllData from 'I18n/init/register/sync/registerAllData';
import { initAppTranslations } from 'I18n/init/setup/AppInit';
import setDocumentTitle from 'I18n/utils/setDocumentTitle';
import lang from 'i2l?query=sporks!../lang/en.lyaml';

// Import extra I18n data
import 'I18n/init/data/baseLocales';
import 'I18n/init/data/currency';
import 'I18n/init/data/publicLocales';

// Rhumb
import historyAdapter from 'react-rhumb/historyAdapterV4';
import rhumbConfig from '../rhumb-config.yaml';
import { RhumbProviderWithOffset } from './CustomRhumbProvider';

// Configure the router
import { Router } from 'react-router-dom';
import { getRootUrl } from 'calling-remote-common/utils/urls';

// User Info
import UserInfoProvider from 'calling-ui-library/user-info/context/UserInfoContext';
import userInfo from 'hub-http/userInfo';
import { ConnectionTypes } from 'calling-cross-tab-library/types/ConnectionTypes';
import { logCallingError } from 'calling-error-reporting/report/error';
import CopilotProvider from 'copilot-toolkit/CopilotProvider';
import { callingComponentDef } from 'navigation-components/config';
import { NavigationComponent } from 'navigation-components/consumer/components';
import WorkerConnection from 'worker-connection-library/WorkerConnection';
import { SelectedProviderContextProvider } from 'calling-remote-common/context/SelectedProviderContext';
import { CallWrapper } from './navigation/components/CallWrapper';
import ThirdPartyWidgetDetailsProvider from 'calling-remote-common/context/ThirdPartyWidgetDetailsContext';
import { isInIFrame } from './utils/isInIframe';
import { jsx as _jsx } from "react/jsx-runtime";
export class App {
  // Kicks off the app. This is intentionally not in the constructor.
  async start() {
    const {
      user,
      gates,
      portal
    } = await userInfo({
      allowSuspended: true
    });
    const I18nProvider = createStandardI18nProvider();
    const langAvailable = initAppTranslations([I18nProvider.register(lang), registerAllData(I18nProvider)]);
    I18nProvider.setLocale({
      locale: user.locale,
      langEnabled: user.lang_enabled,
      timezone: portal && portal.timezone
    });
    await langAvailable;
    setDocumentTitle('calling-remote-app.htmlTitle');
    this.startRouter({
      user,
      gates,
      portal
    });
    WorkerConnection.initialize(ConnectionTypes.EXTERNAL).catch(error => {
      logCallingError({
        errorMessage: `calling-remote-app ${error.message}`,
        extraData: {
          error
        },
        tags: {
          component: 'calling-remote-app App'
        }
      });
    });
  }
  startRouter(_userInfo) {
    const {
      gates
    } = _userInfo;
    const history = createBrowserHistory({
      basename: getRootUrl()
    });
    renderRoot( /*#__PURE__*/_jsx(UIApplication, {
      name: "calling-remote-app",
      children: /*#__PURE__*/_jsx(NavigationComponent.Provider, {
        definition: callingComponentDef,
        enableStandaloneMode: !isInIFrame(),
        definitionParams: {
          gates
        },
        children: /*#__PURE__*/_jsx(RhumbProviderWithOffset, {
          history: historyAdapter(history),
          config: rhumbConfig,
          children: /*#__PURE__*/_jsx(Router, {
            history: history,
            children: /*#__PURE__*/_jsx(CopilotProvider, {
              children: /*#__PURE__*/_jsx(UserInfoProvider, {
                userInfo: _userInfo,
                children: /*#__PURE__*/_jsx(ThirdPartyWidgetDetailsProvider, {
                  children: /*#__PURE__*/_jsx(SelectedProviderContextProvider, {
                    children: /*#__PURE__*/_jsx(NavigationComponent.Renderer, {
                      component: CallWrapper,
                      definition: callingComponentDef,
                      definitionParams: {
                        gates
                      }
                    })
                  })
                })
              })
            })
          })
        })
      })
    }));
  }
}